import {
  Table,
  TableBody,
  TableCell,
  TableRow,
} from '@/common/components/ui/table';
import { Car } from '@/policy/types/PolicyCoverage';

import { CarListTableHeader } from './CarListTableHeader';

interface CarListTableProps {
  cars: Car[];
}

export const CarListTable = ({ cars }: CarListTableProps) => {
  return (
    <div className="w-full overflow-x-auto scrollbar-visible">
      <Table
        noWrapper
        className="min-w-max w-full"
        style={{ tableLayout: 'auto' }}
      >
        <CarListTableHeader />
        <TableBody>
          {cars.map((car) => (
            <TableRow key={car.serialNumber} className="bg-white even:bg-white">
              <TableCell className="border-r border-warm-gray-200 text-center">
                {car.carNumber}
              </TableCell>
              <TableCell className="border-r border-warm-gray-200 text-center">
                {car.year}
              </TableCell>
              <TableCell className="border-r border-warm-gray-200">
                {car.description}
              </TableCell>
              <TableCell className="border-r border-warm-gray-200 text-center">
                {car.serialNumber}
              </TableCell>
              <TableCell className="text-center">
                {car.caracteristiques}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
